// SHA-256 → lowercase hex, via the browser's Web Crypto (SubtleCrypto).
// Used to fingerprint the exact agreement text a member consented to.
export async function sha256Hex(text) {
  const bytes = new TextEncoder().encode(text);
  const digest = await crypto.subtle.digest('SHA-256', bytes);
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');
}
